/**
 * Système de gestion des textes dynamiques pour SOGEIMCO
 * Ce fichier contient toutes les clés de textes utilisées dans l'application
 * Les textes peuvent être modifiés via l'admin Django
 */

export interface TextKey {
    key: string;
    defaultValue: string;
    category: string;
    description: string;
  }
  
  export const TEXT_KEYS: Record<string, TextKey> = {
    // === NAVIGATION ===
    'nav.home': {
      key: 'nav.home',
      defaultValue: 'Accueil',
      category: 'navigation',
      description: 'Lien de navigation vers la page d\'accueil'
    },
    'nav.projects': {
      key: 'nav.projects',
      defaultValue: 'Projets',
      category: 'navigation',
      description: 'Lien de navigation vers la page des projets'
    },
    'nav.about': {
      key: 'nav.about',
      defaultValue: 'À propos',
      category: 'navigation',
      description: 'Lien de navigation vers la page à propos'
    },
    'nav.contact': {
      key: 'nav.contact',
      defaultValue: 'Contact',
      category: 'navigation',
      description: 'Lien de navigation vers la page de contact'
    },
    'nav.login': {
      key: 'nav.login',
      defaultValue: 'Connexion',
      category: 'navigation',
      description: 'Lien de connexion'
    },
    'nav.logout': {
      key: 'nav.logout',
      defaultValue: 'Déconnexion',
      category: 'navigation',
      description: 'Bouton de déconnexion'
    },
    'nav.dashboard': {
      key: 'nav.dashboard',
      defaultValue: 'Mon espace',
      category: 'navigation',
      description: 'Lien vers le tableau de bord client'
    },
    'nav.subscriptions': {
      key: 'nav.subscriptions',
      defaultValue: 'Subscriptions',
      category: 'navigation',
      description: 'Lien vers les souscriptions'
    },
    'nav.schedules': {
      key: 'nav.schedules',
      defaultValue: 'Échéanciers',
      category: 'navigation',
      description: 'Lien vers les échéanciers'
    },
    'nav.payments': {
      key: 'nav.payments',
      defaultValue: 'Paiements',
      category: 'navigation',
      description: 'Lien vers les paiements'
    },
    'nav.documents': {
      key: 'nav.documents',
      defaultValue: 'Documents',
      category: 'navigation',
      description: 'Lien vers les documents'
    },
    'nav.profile': {
      key: 'nav.profile',
      defaultValue: 'Mon profil',
      category: 'navigation',
      description: 'Lien vers le profil utilisateur'
    },
  
    // === HEADER ===
    'header.company_name': {
      key: 'header.company_name',
      defaultValue: 'SOGEIMCO',
      category: 'header',
      description: 'Nom de l\'entreprise dans l\'en-tête'
    },
    'header.notifications': {
      key: 'header.notifications',
      defaultValue: 'Notifications',
      category: 'header',
      description: 'Titre pour les notifications'
    },
  
    // === HOME PAGE ===
    'home.hero.title': {
      key: 'home.hero.title',
      defaultValue: 'Investissez dans l\'immobilier',
      category: 'home',
      description: 'Titre principal de la page d\'accueil'
    },
    'home.hero.subtitle': {
      key: 'home.hero.subtitle',
      defaultValue: 'avec confiance et expertise',
      category: 'home',
      description: 'Sous-titre de la page d\'accueil'
    },
    'home.hero.description': {
      key: 'home.hero.description',
      defaultValue: 'Découvrez nos projets immobiliers d\'exception. Solutions de financement flexibles et accompagnement personnalisé.',
      category: 'home',
      description: 'Description de la page d\'accueil'
    },
    'home.hero.discover_projects': {
      key: 'home.hero.discover_projects',
      defaultValue: 'Découvrir nos projets',
      category: 'home',
      description: 'Bouton pour découvrir les projets'
    },
    'home.hero.contact_us': {
      key: 'home.hero.contact_us',
      defaultValue: 'Nous contacter',
      category: 'home',
      description: 'Bouton de contact'
    },
  
    // === STATS ===
    'stats.homes_created': {
      key: 'stats.homes_created',
      defaultValue: 'Logements créés',
      category: 'stats',
      description: 'Label pour le nombre de logements créés'
    },
    'stats.satisfied_clients': {
      key: 'stats.satisfied_clients',
      defaultValue: 'Clients satisfaits',
      category: 'stats',
      description: 'Label pour le nombre de clients satisfaits'
    },
    'stats.completed_projects': {
      key: 'stats.completed_projects',
      defaultValue: 'Projets réalisés',
      category: 'stats',
      description: 'Label pour le nombre de projets réalisés'
    },
    'stats.warranty': {
      key: 'stats.warranty',
      defaultValue: 'Garantie',
      category: 'stats',
      description: 'Label pour la garantie'
    },
    'stats.warranty_years': {
      key: 'stats.warranty_years',
      defaultValue: '10 ans',
      category: 'stats',
      description: 'Durée de la garantie'
    },
    'stats.paid_installments': {
      key: 'stats.paid_installments',
      defaultValue: 'Nombre de paiements totaux',
      category: 'stats',
      description: 'Label pour le nombre d\'échéances payées'
    },
    'stats.pending_installments': {
      key: 'stats.pending_installments',
      defaultValue: 'Nombre d\'échéances en attente',
      category: 'stats',
      description: 'Label pour le nombre d\'échéances en attente'
    },
    'stats.overdue_installments': {
      key: 'stats.overdue_installments',
      defaultValue: 'Nombre d\'échéances en retard',
      category: 'stats',
      description: 'Label pour le nombre d\'échéances en retard'
    },
    'stats.collection_rate': {
      key: 'stats.collection_rate',
      defaultValue: 'Taux de collecte',

      category: 'stats',
      description: 'Label pour le taux de collecte'
    },
  
    // === PROJECTS SECTION ===
    'home.projects.title': {
      key: 'home.projects.title',
      defaultValue: 'Nos Projets',
      category: 'home',
      description: 'Titre de la section projets'
    },
    'home.projects.description': {
      key: 'home.projects.description',
      defaultValue: 'Découvrez nos réalisations exceptionnelles qui allient modernité, qualité et innovation',
      category: 'home',
      description: 'Description de la section projets'
    },
    'home.projects.see_all': {
      key: 'home.projects.see_all',
      defaultValue: 'Voir tous les projets',
      category: 'home',
      description: 'Lien pour voir tous les projets'
    },
  
    // === NEWS SECTION ===
    'home.news.title': {
      key: 'home.news.title',
      defaultValue: 'Actualités de nos Projets',
      category: 'home',
      description: 'Titre de la section actualités'
    },
    'home.news.description': {
      key: 'home.news.description',
      defaultValue: 'Suivez l\'évolution de nos chantiers en temps réel',
      category: 'home',
      description: 'Description de la section actualités'
    },
  
    // === CTA SECTION ===
    'home.cta.title': {
      key: 'home.cta.title',
      defaultValue: 'Prêt à investir dans un projet immobilier ?',
      category: 'home',
      description: 'Titre de la section call-to-action'
    },
    'home.cta.description': {
      key: 'home.cta.description',
      defaultValue: 'Nos conseillers vous accompagnent dans toutes vos démarches',
      category: 'home',
      description: 'Description de la section call-to-action'
    },
    'home.cta.contact_us': {
      key: 'home.cta.contact_us',
      defaultValue: 'Nous contacter',
      category: 'home',
      description: 'Bouton de contact dans la CTA'
    },
    'home.cta.ask_advice': {
      key: 'home.cta.ask_advice',
      defaultValue: 'Demander un conseil',
      category: 'home',
      description: 'Bouton pour demander un conseil'
    },
  
    // === FOOTER ===
    'footer.contact_us': {
      key: 'footer.contact_us',
      defaultValue: 'Contactez-nous',
      category: 'footer',
      description: 'Titre de la section contact dans le footer'
    },
    'footer.follow_us': {
      key: 'footer.follow_us',
      defaultValue: 'Suivez-nous',
      category: 'footer',
      description: 'Titre de la section réseaux sociaux'
    },
    'footer.quick_links': {
      key: 'footer.quick_links',
      defaultValue: 'Liens rapides',
      category: 'footer',
      description: 'Titre de la section liens rapides'
    },
    'footer.our_projects': {
      key: 'footer.our_projects',
      defaultValue: 'Nos projets',
      category: 'footer',
      description: 'Lien vers les projets dans le footer'
    },
    'footer.about': {
      key: 'footer.about',
      defaultValue: 'À propos',
      category: 'footer',
      description: 'Lien vers la page à propos dans le footer'
    },
    'footer.contact': {
      key: 'footer.contact',
      defaultValue: 'Contact',
      category: 'footer',
      description: 'Lien vers la page contact dans le footer'
    },
    'footer.navigation': {
      key: 'footer.navigation',
      defaultValue: 'Navigation',
      category: 'footer',
      description: 'Titre de la section navigation dans le footer'
    },
    'footer.company_description': {
      key: 'footer.company_description',
      defaultValue: 'Promoteur immobilier de référence en Côte d\'Ivoire, nous développons des projets résidentiels et commerciaux de qualité avec des solutions de financement adaptées.',
      category: 'footer',
      description: 'Description de l\'entreprise dans le footer'
    },
    'footer.services': {
      key: 'footer.services',
      defaultValue: 'Services',
      category: 'footer',
      description: 'Titre de la section services dans le footer'
    },
    'footer.service_apartments': {
      key: 'footer.service_apartments',
      defaultValue: 'Vente d\'appartements',
      category: 'footer',
      description: 'Service vente d\'appartements'
    },
    'footer.service_villas': {
      key: 'footer.service_villas',
      defaultValue: 'Vente de villas',
      category: 'footer',
      description: 'Service vente de villas'
    },
    'footer.service_commercial': {
      key: 'footer.service_commercial',
      defaultValue: 'Espaces commerciaux',
      category: 'footer',
      description: 'Service espaces commerciaux'
    },
    'footer.service_financing': {
      key: 'footer.service_financing',
      defaultValue: 'Financement immobilier',
      category: 'footer',
      description: 'Service financement immobilier'
    },
  
    'footer.copyright': {
      key: 'footer.copyright',
      defaultValue: '© 2024 SOGEIMCO. Tous droits réservés.',
      category: 'footer',
      description: 'Copyright dans le footer'
    },
    'footer.terms': {
      key: 'footer.terms',
      defaultValue: 'Conditions générales',
      category: 'footer',
      description: 'Lien conditions générales'
    },
    'footer.privacy': {
      key: 'footer.privacy',
      defaultValue: 'Politique de confidentialité',
      category: 'footer',
      description: 'Lien politique de confidentialité'
    },
    'footer.legal': {
      key: 'footer.legal',
      defaultValue: 'Mentions légales',
      category: 'footer',
      description: 'Lien mentions légales'
    },
  
    // === ABOUT PAGE ===
    'about.hero.title': {
      key: 'about.hero.title',
      defaultValue: 'À propos de SOGEIMCO',
      category: 'about',
      description: 'Titre principal de la page à propos'
    },
    'about.hero.subtitle': {
      key: 'about.hero.subtitle',
      defaultValue: 'Promoteur immobilier de référence en Côte d\'Ivoire depuis plus de 15 ans, nous transformons vos rêves immobiliers en réalité.',
      category: 'about',
      description: 'Sous-titre de la page à propos'
    },
    'about.story.title': {
      key: 'about.story.title',
      defaultValue: 'Notre Histoire',
      category: 'about',
      description: 'Titre de la section histoire'
    },
    'about.story.content': {
      key: 'about.story.content',
      defaultValue: 'Fondée en 2009, SOGEIMCO s\'est rapidement imposée comme l\'un des promoteurs immobiliers les plus fiables de Côte d\'Ivoire...',
      category: 'about',
      description: 'Contenu de la section histoire'
    },
    'about.mission.title': {
      key: 'about.mission.title',
      defaultValue: 'Notre Mission',
      category: 'about',
      description: 'Titre de la section mission'
    },
    'about.mission.content': {
      key: 'about.mission.content',
      defaultValue: 'Rendre la propriété immobilière accessible à tous les Ivoiriens...',
      category: 'about',
      description: 'Contenu de la section mission'
    },
    'about.vision.title': {
      key: 'about.vision.title',
      defaultValue: 'Notre Vision',
      category: 'about',
      description: 'Titre de la section vision'
    },
    'about.vision.content': {
      key: 'about.vision.content',
      defaultValue: 'Être le promoteur immobilier de référence en Afrique de l\'Ouest...',
      category: 'about',
      description: 'Contenu de la section vision'
    },
    'about.values.title': {
      key: 'about.values.title',
      defaultValue: 'Nos Valeurs',
      category: 'about',
      description: 'Titre de la section valeurs'
    },
    'about.values.subtitle': {
      key: 'about.values.subtitle',
      defaultValue: 'Les principes qui guident notre action au quotidien',
      category: 'about',
      description: 'Sous-titre de la section valeurs'
    },
    'about.team.title': {
      key: 'about.team.title',
      defaultValue: 'Notre Équipe Dirigeante',
      category: 'about',
      description: 'Titre de la section équipe'
    },
    'about.team.subtitle': {
      key: 'about.team.subtitle',
      defaultValue: 'Une équipe expérimentée au service de vos projets',
      category: 'about',
      description: 'Sous-titre de la section équipe'
    },
    'about.cta.title': {
      key: 'about.cta.title',
      defaultValue: 'Prêt à Nous Rejoindre ?',
      category: 'about',
      description: 'Titre de la CTA de la page à propos'
    },
    'about.cta.description': {
      key: 'about.cta.description',
      defaultValue: 'Découvrez nos opportunités immobilières et laissez-nous vous accompagner dans la réalisation de votre projet',
      category: 'about',
      description: 'Description de la CTA de la page à propos'
    },
    'about.cta.see_projects': {
      key: 'about.cta.see_projects',
      defaultValue: 'Voir nos projets',
      category: 'about',
      description: 'Bouton pour voir les projets dans la CTA'
    },
    'about.cta.contact_us': {
      key: 'about.cta.contact_us',
      defaultValue: 'Nous contacter',
      category: 'about',
      description: 'Bouton de contact dans la CTA'
    },
  
    // === VALUES ===
    'values.excellence.title': {
      key: 'values.excellence.title',
      defaultValue: 'Excellence',
      category: 'values',
      description: 'Titre de la valeur excellence'
    },
    'values.excellence.description': {
      key: 'values.excellence.description',
      defaultValue: 'Nous visons l\'excellence dans chaque projet, de la conception à la livraison.',
      category: 'values',
      description: 'Description de la valeur excellence'
    },
    'values.integrity.title': {
      key: 'values.integrity.title',
      defaultValue: 'Intégrité',
      category: 'values',
      description: 'Titre de la valeur intégrité'
    },
    'values.integrity.description': {
      key: 'values.integrity.description',
      defaultValue: 'La transparence et l\'honnêteté guident toutes nos relations avec nos clients.',
      category: 'values',
      description: 'Description de la valeur intégrité'
    },
    'values.partnership.title': {
      key: 'values.partnership.title',
      defaultValue: 'Partenariat',
      category: 'values',
      description: 'Titre de la valeur partenariat'
    },
    'values.partnership.description': {
      key: 'values.partnership.description',
      defaultValue: 'Nous accompagnons nos clients à chaque étape de leur projet immobilier.',
      category: 'values',
      description: 'Description de la valeur partenariat'
    },
    'values.innovation.title': {
      key: 'values.innovation.title',
      defaultValue: 'Innovation',
      category: 'values',
      description: 'Titre de la valeur innovation'
    },
    'values.innovation.description': {
      key: 'values.innovation.description',
      defaultValue: 'Nous intégrons les dernières technologies et tendances architecturales.',
      category: 'values',
      description: 'Description de la valeur innovation'
    },
  
    // === CONTACT PAGE ===
    'contact.hero.title': {
      key: 'contact.hero.title',
      defaultValue: 'Contactez-Nous',
      category: 'contact',
      description: 'Titre principal de la page contact'
    },
    'contact.hero.description': {
      key: 'contact.hero.description',
      defaultValue: 'Notre équipe est à votre disposition pour répondre à toutes vos questions',
      category: 'contact',
      description: 'Description de la page contact'
    },
    'contact.form.title': {
      key: 'contact.form.title',
      defaultValue: 'Envoyez-nous un message',
      category: 'contact',
      description: 'Titre du formulaire de contact'
    },
    'contact.form.description': {
      key: 'contact.form.description',
      defaultValue: 'Remplissez le formulaire ci-dessous et nous vous répondrons rapidement',
      category: 'contact',
      description: 'Description du formulaire de contact'
    },
    'contact.form.name': {
      key: 'contact.form.name',
      defaultValue: 'Nom',
      category: 'contact',
      description: 'Label du champ nom'
    },
    'contact.form.firstname': {
      key: 'contact.form.firstname',
      defaultValue: 'Prénoms',
      category: 'contact',
      description: 'Label du champ prénoms'
    },
    'contact.form.email': {
      key: 'contact.form.email',
      defaultValue: 'Email',
      category: 'contact',
      description: 'Label du champ email'
    },
    'contact.form.phone': {
      key: 'contact.form.phone',
      defaultValue: 'Téléphone',
      category: 'contact',
      description: 'Label du champ téléphone'
    },
    'contact.form.subject': {
      key: 'contact.form.subject',
      defaultValue: 'Sujet',
      category: 'contact',
      description: 'Label du champ sujet'
    },
    'contact.form.message': {
      key: 'contact.form.message',
      defaultValue: 'Message',
      category: 'contact',
      description: 'Label du champ message'
    },
    'contact.form.send': {
      key: 'contact.form.send',
      defaultValue: 'Envoyer le message',
      category: 'contact',
      description: 'Bouton d\'envoi du formulaire'
    },
    'contact.form.sending': {
      key: 'contact.form.sending',
      defaultValue: 'Envoi en cours...',
      category: 'contact',
      description: 'Texte pendant l\'envoi du formulaire'
    },
    'contact.info.title': {
      key: 'contact.info.title',
      defaultValue: 'Informations de Contact',
      category: 'contact',
      description: 'Titre de la section informations de contact'
    },
    'contact.info.address': {
      key: 'contact.info.address',
      defaultValue: 'Adresse',
      category: 'contact',
      description: 'Label pour l\'adresse'
    },
    'contact.info.phone': {
      key: 'contact.info.phone',
      defaultValue: 'Téléphone',
      category: 'contact',
      description: 'Label pour le téléphone'
    },
    'contact.info.email': {
      key: 'contact.info.email',
      defaultValue: 'Email',
      category: 'contact',
      description: 'Label pour l\'email'
    },
    'contact.info.hours': {
      key: 'contact.info.hours',
      defaultValue: 'Horaires',
      category: 'contact',
      description: 'Label pour les horaires'
    },
    'contact.info.address_value': {
      key: 'contact.info.address_value',
      defaultValue: '1 Cocody, Abidjan',
      category: 'contact',
      description: 'Adresse physique de l\'entreprise'
    },
    'contact.info.city_value': {
      key: 'contact.info.city_value',
      defaultValue: 'Côte d\'Ivoire',
      category: 'contact',
      description: 'Ville et pays de l\'entreprise'
    },
    'contact.info.phone_value': {
      key: 'contact.info.phone_value',
      defaultValue: '+225 27 24 31 45 27',
      category: 'contact',
      description: 'Numéro de téléphone principal'
    },
    'contact.info.phone_value_2': {
      key: 'contact.info.phone_value_2',
      defaultValue: '+225 07 57 27 14 67',
      category: 'contact',
      description: 'Numéro de téléphone secondaire'
    },
    'contact.info.email_value': {
      key: 'contact.info.email_value',
      defaultValue: 'info@sogeimco.com',
      category: 'contact',
      description: 'Adresse email principale'
    },
    'contact.info.email_value_2': {
      key: 'contact.info.email_value_2',
      defaultValue: 'contact@sogeimco.com',
      category: 'contact',
      description: 'Adresse email secondaire'
    },
    'contact.info.hours_value': {
      key: 'contact.info.hours_value',
      defaultValue: 'Lun - Ven: 8h00 - 17h30',
      category: 'contact',
      description: 'Horaires de la semaine'
    },
    'contact.info.hours_value_2': {
      key: 'contact.info.hours_value_2',
      defaultValue: 'Sam: 8h00 - 12h00',
      category: 'contact',
      description: 'Horaires du samedi'
    },
    'contact.office.headquarters.name': {
      key: 'contact.office.headquarters.name',
      defaultValue: 'Siège Social - Plateau',
      category: 'contact',
      description: 'Nom du siège social'
    },
    'contact.office.headquarters.address': {
      key: 'contact.office.headquarters.address',
      defaultValue: '1 Cocody, Abidjan',
      category: 'contact',
      description: 'Adresse du siège social'
    },
    'contact.office.headquarters.phone': {
      key: 'contact.office.headquarters.phone',
      defaultValue: '+225 27 24 31 45 27',
      category: 'contact',
      description: 'Téléphone du siège social'
    },
    'contact.office.headquarters.hours': {
      key: 'contact.office.headquarters.hours',
      defaultValue: 'Lun - Ven: 8h00 - 17h30',
      category: 'contact',
      description: 'Horaires du siège social'
    },
    'contact.office.cocody.name': {
      key: 'contact.office.cocody.name',
      defaultValue: 'Bureau Cocody',
      category: 'contact',
      description: 'Nom du bureau Cocody'
    },
    'contact.office.cocody.address': {
      key: 'contact.office.cocody.address',
      defaultValue: 'Riviera 2, près du lycée Sainte-Marie',
      category: 'contact',
      description: 'Adresse du bureau Cocody'
    },
    'contact.office.cocody.phone': {
      key: 'contact.office.cocody.phone',
      defaultValue: '+225 07 57 27 14 67',
      category: 'contact',
      description: 'Téléphone du bureau Cocody'
    },
    'contact.office.cocody.hours': {
      key: 'contact.office.cocody.hours',
      defaultValue: 'Lun - Ven: 8h30 - 17h00',
      category: 'contact',
      description: 'Horaires du bureau Cocody'
    },
    'contact.office.songon.name': {
      key: 'contact.office.songon.name',
      defaultValue: 'Showroom Songon',
      category: 'contact',
      description: 'Nom du showroom Songon'
    },
    'contact.office.songon.address': {
      key: 'contact.office.songon.address',
      defaultValue: 'Site des Résidences Challenge',
      category: 'contact',
      description: 'Adresse du showroom Songon'
    },
    'contact.office.songon.phone': {
      key: 'contact.office.songon.phone',
      defaultValue: '+225 05 44 55 66 77',
      category: 'contact',
      description: 'Téléphone du showroom Songon'
    },
    'contact.office.songon.hours': {
      key: 'contact.office.songon.hours',
      defaultValue: 'Mar - Dim: 9h00 - 16h00',
      category: 'contact',
      description: 'Horaires du showroom Songon'
    },
    'project.detail.back_to_projects': {
      key: 'project.detail.back_to_projects',
      defaultValue: 'Retour aux projets',
      category: 'project',
      description: 'Lien retour vers la liste des projets'
    },
    'project.detail.interested_title': {
      key: 'project.detail.interested_title',
      defaultValue: 'Intéressé par ce projet ?',
      category: 'project',
      description: 'Titre de la section contact dans les détails du projet'
    },
    'project.detail.ask_information': {
      key: 'project.detail.ask_information',
      defaultValue: 'Demander des informations',
      category: 'project',
      description: 'Bouton pour demander des informations sur le projet'
    },
    'project.detail.contact_us': {
      key: 'project.detail.contact_us',
      defaultValue: 'Nous contacter',
      category: 'project',
      description: 'Bouton pour nous contacter'
    },
    'project.detail.availability': {
      key: 'project.detail.availability',
      defaultValue: 'Disponibilité',
      category: 'project',
      description: 'Titre de la section disponibilité'
    },
    'project.detail.available_houses': {
      key: 'project.detail.available_houses',
      defaultValue: 'Logements disponibles',
      category: 'project',
      description: 'Label pour le nombre de logements disponibles'
    },
    'project.detail.total_houses': {
      key: 'project.detail.total_houses',
      defaultValue: 'Total de logements',
      category: 'project',
      description: 'Label pour le total de logements'
    },
    'echeanciers.title': {
      key: 'echeanciers.title',
      defaultValue: 'Échéanciers',
      category: 'echeanciers',
      description: 'Titre de la page échéanciers'
    },
    'echeanciers.description': {
      key: 'echeanciers.description',
      defaultValue: 'Suivez vos échéances de paiement et leur statut',
      category: 'echeanciers',
      description: 'Description de la page échéanciers'
    },
    'echeanciers.filters': {
      key: 'echeanciers.filters',
      defaultValue: 'Filtres',
      category: 'echeanciers',
      description: 'Titre de la section filtres'
    },
    'echeanciers.search': {
      key: 'echeanciers.search',
      defaultValue: 'Rechercher',
      category: 'echeanciers',
      description: 'Bouton de recherche'
    },
    'echeanciers.reset': {
      key: 'echeanciers.reset',
      defaultValue: 'Réinitialiser',
      category: 'echeanciers',
      description: 'Bouton de réinitialisation des filtres'
    },
    'echeanciers.export': {
      key: 'echeanciers.export',
      defaultValue: 'Exporter en PDF',
      category: 'echeanciers',
      description: 'Bouton d\'export PDF'
    },
    'echeanciers.status.all': {
      key: 'echeanciers.status.all',
      defaultValue: 'Tous les statuts',
      category: 'echeanciers',
      description: 'Option filtre pour tous les statuts'
    },
    'echeanciers.status.pending': {
      key: 'echeanciers.status.pending',
      defaultValue: 'En attente',
      category: 'echeanciers',
      description: 'Statut échéance en attente'
    },
    'echeanciers.status.paid': {
      key: 'echeanciers.status.paid',
      defaultValue: 'Payé',
      category: 'echeanciers',
      description: 'Statut échéance payée'
    },
    'echeanciers.status.overdue': {
      key: 'echeanciers.status.overdue',
      defaultValue: 'En retard',
      category: 'echeanciers',
      description: 'Statut échéance en retard'
    },
    'documents.title': {
      key: 'documents.title',
      defaultValue: 'Documents',
      category: 'documents',
      description: 'Titre de la page documents'
    },
    'documents.description': {
      key: 'documents.description',
      defaultValue: 'Consultez et téléchargez vos documents',
      category: 'documents',
      description: 'Description de la page documents'
    },
    'documents.refresh': {
      key: 'documents.refresh',
      defaultValue: 'Actualiser',
      category: 'documents',
      description: 'Bouton actualiser les documents'
    },
    'documents.retry': {
      key: 'documents.retry',
      defaultValue: 'Réessayer',
      category: 'documents',
      description: 'Bouton réessayer en cas d\'erreur'
    },
    'documents.loading': {
      key: 'documents.loading',
      defaultValue: 'Chargement des documents...',
      category: 'documents',
      description: 'Message de chargement'
    },
    'notifications.title': {
      key: 'notifications.title',
      defaultValue: 'Centre d\'informations',
      category: 'notifications',
      description: 'Titre de la page notifications'
    },
    'notifications.description': {
      key: 'notifications.description',
      defaultValue: 'Notifications et actualités de vos projets',
      category: 'notifications',
      description: 'Description de la page notifications'
    },
    'notifications.refresh': {
      key: 'notifications.refresh',
      defaultValue: 'Actualiser',
      category: 'notifications',
      description: 'Bouton actualiser les notifications'
    },
    'notifications.mark_all_read': {
      key: 'notifications.mark_all_read',
      defaultValue: 'Marquer tout comme lu',
      category: 'notifications',
      description: 'Bouton marquer toutes les notifications comme lues'
    },
    'notifications.tab_notifications': {
      key: 'notifications.tab_notifications',
      defaultValue: 'Notifications',
      category: 'notifications',
      description: 'Onglet notifications'
    },
    'notifications.tab_updates': {
      key: 'notifications.tab_updates',
      defaultValue: 'Actualités projets',
      category: 'notifications',
      description: 'Onglet actualités projets'
    },
    'profile.title': {
      key: 'profile.title',
      defaultValue: 'Mon Profil',
      category: 'profile',
      description: 'Titre de la page profil'
    },
    'profile.description': {
      key: 'profile.description',
      defaultValue: 'Gérez vos informations personnelles',
      category: 'profile',
      description: 'Description de la page profil'
    },
    'profile.edit': {
      key: 'profile.edit',
      defaultValue: 'Modifier',
      category: 'profile',
      description: 'Bouton modifier le profil'
    },
    'profile.save': {
      key: 'profile.save',
      defaultValue: 'Enregistrer',
      category: 'profile',
      description: 'Bouton enregistrer les modifications'
    },
    'profile.cancel': {
      key: 'profile.cancel',
      defaultValue: 'Annuler',
      category: 'profile',
      description: 'Bouton annuler les modifications'
    },
    'profile.change_password': {
      key: 'profile.change_password',
      defaultValue: 'Changer le mot de passe',
      category: 'profile',
      description: 'Bouton changer le mot de passe'
    },
    'subscription.detail.title': {
      key: 'subscription.detail.title',
      defaultValue: 'Détails de la Souscription',
      category: 'subscription',
      description: 'Titre de la page détails souscription'
    },
    'subscription.detail.back_dashboard': {
      key: 'subscription.detail.back_dashboard',
      defaultValue: 'Retour au dashboard',
      category: 'subscription',
      description: 'Bouton retour au dashboard'
    },
    'subscription.detail.not_found': {
      key: 'subscription.detail.not_found',
      defaultValue: 'Souscription non trouvée',
      category: 'subscription',
      description: 'Message souscription non trouvée'
    },
    'payments.my_payments': {
      key: 'payments.my_payments',
      defaultValue: 'Paiements',
      category: 'payments',
      description: 'Titre de la page des paiements'
    },
    'payments.subscription_payments': {
      key: 'payments.subscription_payments',
      defaultValue: 'Paiements de la souscription',
      category: 'payments',
      description: 'Titre des paiements pour une souscription spécifique'
    },
    'payments.all_description': {
      key: 'payments.all_description',
      defaultValue: 'Tous vos paiements en un seul endroit',
      category: 'payments',
      description: 'Description de la page des paiements'
    },
    'contact.offices.title': {
      key: 'contact.offices.title',
      defaultValue: 'Nos Bureaux',
      category: 'contact',
      description: 'Titre de la section bureaux'
    },

    'contact.map.description': {
      key: 'contact.map.description',
      defaultValue: 'Visitez-nous dans nos bureaux à Abidjan',
      category: 'contact',
      description: 'Description de la section carte'
    },
  
    // === PROJECTS PAGE ===
    'projects.title': {
      key: 'projects.title',
      defaultValue: 'Nos Projets Immobiliers',
      category: 'projects',
      description: 'Titre de la page projets'
    },
    'projects.description': {
      key: 'projects.description',
      defaultValue: 'Découvrez nos projets résidentiels et commerciaux en Côte d\'Ivoire',
      category: 'projects',
      description: 'Description de la page projets'
    },
    'projects.search.placeholder': {
      key: 'projects.search.placeholder',
      defaultValue: 'Rechercher un projet...',
      category: 'projects',
      description: 'Placeholder du champ de recherche'
    },
    'projects.filter.all_statuses': {
      key: 'projects.filter.all_statuses',
      defaultValue: 'Tous les statuts',
      category: 'projects',
      description: 'Option pour tous les statuts'
    },
    'projects.filter.coming_soon': {
      key: 'projects.filter.coming_soon',
      defaultValue: 'À venir',
      category: 'projects',
      description: 'Option pour les projets à venir'
    },
    'projects.filter.in_progress': {
      key: 'projects.filter.in_progress',
      defaultValue: 'En cours',
      category: 'projects',
      description: 'Option pour les projets en cours'
    },
    'projects.filter.completed': {
      key: 'projects.filter.completed',
      defaultValue: 'Terminé',
      category: 'projects',
      description: 'Option pour les projets terminés'
    },
    'projects.sort.name': {
      key: 'projects.sort.name',
      defaultValue: 'Nom du projet',
      category: 'projects',
      description: 'Option de tri par nom'
    },
    'projects.sort.price': {
      key: 'projects.sort.price',
      defaultValue: 'Budget',
      category: 'projects',
      description: 'Option de tri par prix'
    },
    'projects.sort.date': {
      key: 'projects.sort.date',
      defaultValue: 'Date de lancement',
      category: 'projects',
      description: 'Option de tri par date'
    },
    'projects.sort.by': {
      key: 'projects.sort.by',
      defaultValue: 'Trier par:',
      category: 'projects',
      description: 'Label pour le tri'
    },
    'projects.results.count': {
      key: 'projects.results.count',
      defaultValue: 'projet trouvé',
      category: 'projects',
      description: 'Texte pour le nombre de résultats (singulier)'
    },
    'projects.results.count_plural': {
      key: 'projects.results.count_plural',
      defaultValue: 'projets trouvés',
      category: 'projects',
      description: 'Texte pour le nombre de résultats (pluriel)'
    },
    'projects.empty.title': {
      key: 'projects.empty.title',
      defaultValue: 'Aucun projet trouvé',
      category: 'projects',
      description: 'Titre quand aucun projet n\'est trouvé'
    },
    'projects.empty.description': {
      key: 'projects.empty.description',
      defaultValue: 'Essayez de modifier vos critères de recherche',
      category: 'projects',
      description: 'Description quand aucun projet n\'est trouvé'
    },
    'projects.empty.reset': {
      key: 'projects.empty.reset',
      defaultValue: 'Réinitialiser les filtres',
      category: 'projects',
      description: 'Bouton pour réinitialiser les filtres'
    },
  
    // === PROJECT CARD ===
    'project.status.in_progress': {
      key: 'project.status.in_progress',
      defaultValue: 'En cours',
      category: 'project',
      description: 'Statut projet en cours'
    },
    'project.status.coming_soon': {
      key: 'project.status.coming_soon',
      defaultValue: 'À venir',
      category: 'project',
      description: 'Statut projet à venir'
    },
    'project.status.completed': {
      key: 'project.status.completed',
      defaultValue: 'Terminé',
      category: 'project',
      description: 'Statut projet terminé'
    },
    'project.status.suspended': {
      key: 'project.status.suspended',
      defaultValue: 'Suspendu',
      category: 'project',
      description: 'Statut projet suspendu'
    },
    'project.progress': {
      key: 'project.progress',
      defaultValue: 'Avancement',
      category: 'project',
      description: 'Label pour l\'avancement du projet'
    },
    'project.view_details': {
      key: 'project.view_details',
      defaultValue: 'Voir détails',
      category: 'project',
      description: 'Lien pour voir les détails du projet'
    },
  
    // === LOGIN PAGE ===
    'login.title': {
      key: 'login.title',
      defaultValue: 'Connexion à votre compte',
      category: 'auth',
      description: 'Titre de la page de connexion'
    },
    'login.description': {
      key: 'login.description',
      defaultValue: 'Accédez à votre espace personnel pour suivre vos projets',
      category: 'auth',
      description: 'Description de la page de connexion'
    },
    'login.email': {
      key: 'login.email',
      defaultValue: 'Adresse email',
      category: 'auth',
      description: 'Label du champ email'
    },
    'login.password': {
      key: 'login.password',
      defaultValue: 'Mot de passe',
      category: 'auth',
      description: 'Label du champ mot de passe'
    },
    'login.remember': {
      key: 'login.remember',
      defaultValue: 'Se souvenir de moi',
      category: 'auth',
      description: 'Label de la case à cocher se souvenir'
    },
    'login.forgot_password': {
      key: 'login.forgot_password',
      defaultValue: 'Mot de passe oublié ?',
      category: 'auth',
      description: 'Lien mot de passe oublié'
    },
    'login.submit': {
      key: 'login.submit',
      defaultValue: 'Se connecter',
      category: 'auth',
      description: 'Bouton de connexion'
    },
    'login.new_client': {
      key: 'login.new_client',
      defaultValue: 'Nouveau client ?',
      category: 'auth',
      description: 'Texte pour nouveau client'
    },
    'login.contact_us': {
      key: 'login.contact_us',
      defaultValue: 'Nous contacter',
      category: 'auth',
      description: 'Bouton pour nous contacter'
    },
    'login.terms': {
      key: 'login.terms',
      defaultValue: 'conditions d\'utilisation',
      category: 'auth',
      description: 'Lien vers les conditions d\'utilisation'
    },
    'login.privacy': {
      key: 'login.privacy',
      defaultValue: 'politique de confidentialité',
      category: 'auth',
      description: 'Lien vers la politique de confidentialité'
    },
    'login.error': {
      key: 'login.error',
      defaultValue: 'Email ou mot de passe incorrect',
      category: 'auth',
      description: 'Message d\'erreur de connexion'
    },
  
    // === DASHBOARD ===
    'dashboard.welcome': {
      key: 'dashboard.welcome',
      defaultValue: 'Bienvenue,',
      category: 'dashboard',
      description: 'Message de bienvenue sur le tableau de bord'
    },
    'dashboard.description': {
      key: 'dashboard.description',
      defaultValue: 'Voici un aperçu de vos projets immobiliers',
      category: 'dashboard',
      description: 'Description du tableau de bord'
    },
    'dashboard.my_subscriptions': {
      key: 'dashboard.my_subscriptions',
      defaultValue: 'Mes Souscriptions',
      category: 'dashboard',
      description: 'Label pour mes souscriptions'
    },
    'dashboard.amount_paid': {
      key: 'dashboard.amount_paid',
      defaultValue: 'Montant Payé',
      category: 'dashboard',
      description: 'Label pour le montant payé'
    },
    'dashboard.remaining_amount': {
      key: 'dashboard.remaining_amount',
      defaultValue: 'Reste à Payer',
      category: 'dashboard',
      description: 'Label pour le montant restant'
    },
    'dashboard.active_subscriptions': {
      key: 'dashboard.active_subscriptions',
      defaultValue: 'Mes Souscriptions actives',
      category: 'dashboard',
      description: 'Titre de la section souscriptions actives'
    },
    'dashboard.see_all': {
      key: 'dashboard.see_all',
      defaultValue: 'Voir tout',
      category: 'dashboard',
      description: 'Lien pour voir tout'
    },
    'dashboard.last_payments': {
      key: 'dashboard.last_payments',
      defaultValue: '5 Derniers paiements',
      category: 'dashboard',
      description: 'Titre de la section derniers paiements'
    },
    'dashboard.project_news': {
      key: 'dashboard.project_news',
      defaultValue: 'Actualités de vos projets',
      category: 'dashboard',
      description: 'Titre de la section actualités'
    },
    'dashboard.quick_stats': {
      key: 'dashboard.quick_stats',
      defaultValue: 'Statistiques rapides',
      category: 'dashboard',
      description: 'Titre de la section statistiques'
    },
    'dashboard.no_subscriptions': {
      key: 'dashboard.no_subscriptions',
      defaultValue: 'Aucune souscription',
      category: 'dashboard',
      description: 'Message quand aucune souscription'
    },
    'dashboard.no_subscriptions_desc': {
      key: 'dashboard.no_subscriptions_desc',
      defaultValue: 'Vous n\'avez pas encore souscrit à un projet',
      category: 'dashboard',
      description: 'Description quand aucune souscription'
    },
    'dashboard.discover_projects': {
      key: 'dashboard.discover_projects',
      defaultValue: 'Découvrir nos projets',
      category: 'dashboard',
      description: 'Bouton pour découvrir les projets'
    },
    'dashboard.no_payments': {
      key: 'dashboard.no_payments',
      defaultValue: 'Aucun paiement enregistré',
      category: 'dashboard',
      description: 'Message quand aucun paiement'
    },
    'dashboard.no_news': {
      key: 'dashboard.no_news',
      defaultValue: 'Aucune actualité récente',
      category: 'dashboard',
      description: 'Message quand aucune actualité'
    },
  
    // === SUBSCRIPTIONS PAGE ===
    'subscriptions.title': {
      key: 'subscriptions.title',
      defaultValue: 'Mes Souscriptions',
      category: 'subscriptions',
      description: 'Titre de la page souscriptions'
    },
    'subscriptions.description': {
      key: 'subscriptions.description',
      defaultValue: 'Suivez l\'évolution de vos investissements immobiliers',
      category: 'subscriptions',
      description: 'Description de la page souscriptions'
    },
    'subscriptions.refresh': {
      key: 'subscriptions.refresh',
      defaultValue: 'Actualiser',
      category: 'subscriptions',
      description: 'Bouton d\'actualisation'
    },
    'subscriptions.export': {
      key: 'subscriptions.export',
      defaultValue: 'Exporter',
      category: 'subscriptions',
      description: 'Bouton d\'export'
    },
    'subscriptions.total': {
      key: 'subscriptions.total',
      defaultValue: 'Total Souscriptions',
      category: 'subscriptions',
      description: 'Label pour le total des souscriptions'
    },
    'subscriptions.active': {
      key: 'subscriptions.active',
      defaultValue: 'Actives',
      category: 'subscriptions',
      description: 'Label pour les souscriptions actives'
    },
    'subscriptions.total_paid': {
      key: 'subscriptions.total_paid',
      defaultValue: 'Total Payé',
      category: 'subscriptions',
      description: 'Label pour le total payé'
    },
    'subscriptions.remaining': {
      key: 'subscriptions.remaining',
      defaultValue: 'Reste à Payer',
      category: 'subscriptions',
      description: 'Label pour le reste à payer'
    },
    'subscriptions.search.placeholder': {
      key: 'subscriptions.search.placeholder',
      defaultValue: 'Rechercher par projet, logement...',
      category: 'subscriptions',
      description: 'Placeholder de recherche'
    },
    'subscriptions.filter.all': {
      key: 'subscriptions.filter.all',
      defaultValue: 'Tous les statuts',
      category: 'subscriptions',
      description: 'Option tous les statuts'
    },
    'subscriptions.filter.active': {
      key: 'subscriptions.filter.active',
      defaultValue: 'Actives',
      category: 'subscriptions',
      description: 'Option souscriptions actives'
    },
    'subscriptions.filter.suspended': {
      key: 'subscriptions.filter.suspended',
      defaultValue: 'Suspendues',
      category: 'subscriptions',
      description: 'Option souscriptions suspendues'
    },
    'subscriptions.filter.completed': {
      key: 'subscriptions.filter.completed',
      defaultValue: 'Terminées',
      category: 'subscriptions',
      description: 'Option souscriptions terminées'
    },
    'subscriptions.filter.cancelled': {
      key: 'subscriptions.filter.cancelled',
      defaultValue: 'Annulées',
      category: 'subscriptions',
      description: 'Option souscriptions annulées'
    },
    'subscriptions.sort.recent': {
      key: 'subscriptions.sort.recent',
      defaultValue: 'Plus récentes',
      category: 'subscriptions',
      description: 'Option tri par plus récentes'
    },
    'subscriptions.sort.oldest': {
      key: 'subscriptions.sort.oldest',
      defaultValue: 'Plus anciennes',
      category: 'subscriptions',
      description: 'Option tri par plus anciennes'
    },
    'subscriptions.sort.price_desc': {
      key: 'subscriptions.sort.price_desc',
      defaultValue: 'Prix décroissant',
      category: 'subscriptions',
      description: 'Option tri prix décroissant'
    },
    'subscriptions.sort.price_asc': {
      key: 'subscriptions.sort.price_asc',
      defaultValue: 'Prix croissant',
      category: 'subscriptions',
      description: 'Option tri prix croissant'
    },
  
    // === PAYMENTS PAGE ===
    'payments.title': {
      key: 'payments.title',
      defaultValue: 'Paiements',
      category: 'payments',
      description: 'Titre de la page paiements'
    },
    'payments.subscription.title': {
      key: 'payments.subscription.title',
      defaultValue: 'Paiements de la souscription',
      category: 'payments',
      description: 'Titre pour les paiements d\'une souscription'
    },
    'payments.description': {
      key: 'payments.description',
      defaultValue: 'Historique et suivi de tous vos paiements',
      category: 'payments',
      description: 'Description de la page paiements'
    },
    'payments.subscription.description': {
      key: 'payments.subscription.description',
      defaultValue: 'Historique des paiements pour cette souscription spécifique',
      category: 'payments',
      description: 'Description pour les paiements d\'une souscription'
    },
    'payments.loading': {
      key: 'payments.loading',
      defaultValue: 'Chargement des paiements...',
      category: 'payments',
      description: 'Message de chargement'
    },
    'payments.total_paid': {
      key: 'payments.total_paid',
      defaultValue: 'Total Payé',
      category: 'payments',
      description: 'Label pour le total payé'
    },
    'payments.pending': {
      key: 'payments.pending',
      defaultValue: 'En Attente',
      category: 'payments',
      description: 'Label pour les paiements en attente'
    },
    'payments.count': {
      key: 'payments.count',
      defaultValue: 'Nombre de Paiements',
      category: 'payments',
      description: 'Label pour le nombre de paiements'
    },
    'payments.all_statuses': {
      key: 'payments.all_statuses',
      defaultValue: 'Tous les statuts',
      category: 'payments',
      description: 'Option tous les statuts de paiement'
    },
    'payments.validated': {
      key: 'payments.validated',
      defaultValue: 'Validé',
      category: 'payments',
      description: 'Statut paiement validé'
    },
    'payments.rejected': {
      key: 'payments.rejected',
      defaultValue: 'Rejeté',
      category: 'payments',
      description: 'Statut paiement rejeté'
    },
    'payments.filter_by_subscription': {
      key: 'payments.filter_by_subscription',
      defaultValue: 'Filtrer par souscription',
      category: 'payments',
      description: 'Label pour filtrer par souscription'
    },
    'payments.loading_subscription': {
      key: 'payments.loading_subscription',
      defaultValue: 'Chargement des souscriptions...',
      category: 'payments',
      description: 'Message de chargement des souscriptions'
    },
    'payments.remove_filter': {
      key: 'payments.remove_filter',
      defaultValue: 'Supprimer le filtre',
      category: 'payments',
      description: 'Titre du bouton pour supprimer le filtre'
    },
    'payments.search_placeholder': {
      key: 'payments.search_placeholder',
      defaultValue: 'Rechercher un paiement...',
      category: 'payments',
      description: 'Placeholder de recherche'
    },
    
    'payments.last_date': {
      key: 'payments.last_date',
      defaultValue: 'Date du dernier paiement',
      category: 'payments',
      description: 'Label pour la date du dernier paiement'
    },
    'payments.search.placeholder': {
      key: 'payments.search.placeholder',
      defaultValue: 'Rechercher par référence...',
      category: 'payments',
      description: 'Placeholder de recherche'
    },
    'payments.filter.all': {
      key: 'payments.filter.all',
      defaultValue: 'Tous les statuts',
      category: 'payments',
      description: 'Option tous les statuts'
    },
    'payments.filter.validated': {
      key: 'payments.filter.validated',
      defaultValue: 'Validé',
      category: 'payments',
      description: 'Option paiements validés'
    },
    'payments.filter.pending': {
      key: 'payments.filter.pending',
      defaultValue: 'En attente',
      category: 'payments',
      description: 'Option paiements en attente'
    },
    'payments.filter.rejected': {
      key: 'payments.filter.rejected',
      defaultValue: 'Rejeté',
      category: 'payments',
      description: 'Option paiements rejetés'
    },
    'payments.sort.recent': {
      key: 'payments.sort.recent',
      defaultValue: 'Plus récent',
      category: 'payments',
      description: 'Option tri plus récent'
    },
    'payments.sort.oldest': {
      key: 'payments.sort.oldest',
      defaultValue: 'Plus ancien',
      category: 'payments',
      description: 'Option tri plus ancien'
    },
    'payments.sort.amount_desc': {
      key: 'payments.sort.amount_desc',
      defaultValue: 'Montant décroissant',
      category: 'payments',
      description: 'Option tri montant décroissant'
    },
    'payments.sort.amount_asc': {
      key: 'payments.sort.amount_asc',
      defaultValue: 'Montant croissant',
      category: 'payments',
      description: 'Option tri montant croissant'
    },
    'payments.download_invoice': {
      key: 'payments.download_invoice',
      defaultValue: 'Télécharger la facture',
      category: 'payments',
      description: 'Bouton pour télécharger la facture'
    },
    'payments.invoice_processing': {
      key: 'payments.invoice_processing',
      defaultValue: 'Facture en cours',
      category: 'payments',
      description: 'Message facture en cours'
    },
    'payments.not_available': {
      key: 'payments.not_available',
      defaultValue: 'Non disponible',
      category: 'payments',
      description: 'Message non disponible'
    },
    'payments.empty.title': {
      key: 'payments.empty.title',
      defaultValue: 'Aucun paiement trouvé',
      category: 'payments',
      description: 'Titre quand aucun paiement'
    },
    'payments.empty.subscription.title': {
      key: 'payments.empty.subscription.title',
      defaultValue: 'Aucun paiement pour cette souscription',
      category: 'payments',
      description: 'Titre quand aucun paiement pour une souscription'
    },
    'payments.empty.description': {
      key: 'payments.empty.description',
      defaultValue: 'Aucun paiement ne correspond à vos critères de recherche',
      category: 'payments',
      description: 'Description quand aucun paiement'
    },
    'payments.empty.subscription.description': {
      key: 'payments.empty.subscription.description',
      defaultValue: 'Cette souscription n\'a encore aucun paiement enregistré',
      category: 'payments',
      description: 'Description quand aucun paiement pour une souscription'
    },
    'payments.reset_filters': {
      key: 'payments.reset_filters',
      defaultValue: 'Réinitialiser les filtres',
      category: 'payments',
      description: 'Bouton pour réinitialiser les filtres'
    },
  
    // === COMMON ===
    'common.loading': {
      key: 'common.loading',
      defaultValue: 'Chargement...',
      category: 'common',
      description: 'Message de chargement générique'
    },
    'common.error': {
      key: 'common.error',
      defaultValue: 'Une erreur s\'est produite',
      category: 'common',
      description: 'Message d\'erreur générique'
    },
    'common.retry': {
      key: 'common.retry',
      defaultValue: 'Réessayer',
      category: 'common',
      description: 'Bouton pour réessayer'
    },
    'common.save': {
      key: 'common.save',
      defaultValue: 'Enregistrer',
      category: 'common',
      description: 'Bouton d\'enregistrement'
    },
    'common.cancel': {
      key: 'common.cancel',
      defaultValue: 'Annuler',
      category: 'common',
      description: 'Bouton d\'annulation'
    },
    'common.edit': {
      key: 'common.edit',
      defaultValue: 'Modifier',
      category: 'common',
      description: 'Bouton de modification'
    },
    'common.delete': {
      key: 'common.delete',
      defaultValue: 'Supprimer',
      category: 'common',
      description: 'Bouton de suppression'
    },
    'common.confirm': {
      key: 'common.confirm',
      defaultValue: 'Confirmer',
      category: 'common',
      description: 'Bouton de confirmation'
    },
    'common.close': {
      key: 'common.close',
      defaultValue: 'Fermer',
      category: 'common',
      description: 'Bouton de fermeture'
    },
    'common.back': {
      key: 'common.back',
      defaultValue: 'Retour',
      category: 'common',
      description: 'Bouton de retour'
    },
    'common.next': {
      key: 'common.next',
      defaultValue: 'Suivant',
      category: 'common',
      description: 'Bouton suivant'
    },
    'common.previous': {
      key: 'common.previous',
      defaultValue: 'Précédent',
      category: 'common',
      description: 'Bouton précédent'
    },
    'common.search': {
      key: 'common.search',
      defaultValue: 'Rechercher',
      category: 'common',
      description: 'Bouton de recherche'
    },
    'common.filter': {
      key: 'common.filter',
      defaultValue: 'Filtrer',
      category: 'common',
      description: 'Bouton de filtre'
    },
    'common.sort': {
      key: 'common.sort',
      defaultValue: 'Trier',
      category: 'common',
      description: 'Bouton de tri'
    },
    'common.refresh': {
      key: 'common.refresh',
      defaultValue: 'Actualiser',
      category: 'common',
      description: 'Bouton d\'actualisation'
    },
    'common.export': {
      key: 'common.export',
      defaultValue: 'Exporter',
      category: 'common',
      description: 'Bouton d\'export'
    },
    'common.download': {
      key: 'common.download',
      defaultValue: 'Télécharger',
      category: 'common',
      description: 'Bouton de téléchargement'
    },
    'common.upload': {
      key: 'common.upload',
      defaultValue: 'Téléverser',
      category: 'common',
      description: 'Bouton de téléversement'
    },
    'common.view': {
      key: 'common.view',
      defaultValue: 'Voir',
      category: 'common',
      description: 'Bouton pour voir'
    },
    'common.details': {
      key: 'common.details',
      defaultValue: 'Détails',
      category: 'common',
      description: 'Bouton pour voir les détails'
    },
    'common.more': {
      key: 'common.more',
      defaultValue: 'Plus',
      category: 'common',
      description: 'Bouton pour voir plus'
    },
    'common.less': {
      key: 'common.less',
      defaultValue: 'Moins',
      category: 'common',
      description: 'Bouton pour voir moins'
    },
    'common.required': {
      key: 'common.required',
      defaultValue: 'Obligatoire',
      category: 'common',
      description: 'Indicateur de champ obligatoire'
    },
    'common.optional': {
      key: 'common.optional',
      defaultValue: 'Optionnel',
      category: 'common',
      description: 'Indicateur de champ optionnel'
    },

    // === FORM SUBJECTS ===
    'contact.subject.information': {
      key: 'contact.subject.information',
      defaultValue: 'Demande d\'information',
      category: 'contact',
      description: 'Sujet de contact - demande d\'information'
    },
    'contact.subject.project_info': {
      key: 'contact.subject.project_info',
      defaultValue: 'Information sur un projet',
      category: 'contact',
      description: 'Sujet de contact - information sur un projet'
    },
    'contact.subject.project_question': {
      key: 'contact.subject.project_question',
      defaultValue: 'Question sur un projet',
      category: 'contact',
      description: 'Sujet de contact - question sur un projet'
    },
    'contact.subject.financing': {
      key: 'contact.subject.financing',
      defaultValue: 'Financement',
      category: 'contact',
      description: 'Sujet de contact - financement'
    },
    'contact.subject.visit': {
      key: 'contact.subject.visit',
      defaultValue: 'Demande de visite',
      category: 'contact',
      description: 'Sujet de contact - demande de visite'
    },
    'contact.subject.support': {
      key: 'contact.subject.support',
      defaultValue: 'Support client',
      category: 'contact',
      description: 'Sujet de contact - support client'
    },
    'contact.subject.other': {
      key: 'contact.subject.other',
      defaultValue: 'Autre',
      category: 'contact',
      description: 'Sujet de contact - autre'
    },

    // === SUBSCRIPTION STATUS ===
    'subscription.status.active': {
      key: 'subscription.status.active',
      defaultValue: 'Active',
      category: 'subscription',
      description: 'Statut souscription active'
    },
    'subscription.status.suspended': {
      key: 'subscription.status.suspended',
      defaultValue: 'Suspendue',
      category: 'subscription',
      description: 'Statut souscription suspendue'
    },
    'subscription.status.completed': {
      key: 'subscription.status.completed',
      defaultValue: 'Terminée',
      category: 'subscription',
      description: 'Statut souscription terminée'
    },
    'subscription.status.cancelled': {
      key: 'subscription.status.cancelled',
      defaultValue: 'Annulée',
      category: 'subscription',
      description: 'Statut souscription annulée'
    },

    // === PAYMENT STATUS ===
    'payment.status.validated': {
      key: 'payment.status.validated',
      defaultValue: 'Validé',
      category: 'payment',
      description: 'Statut paiement validé'
    },
    'payment.status.pending': {
      key: 'payment.status.pending',
      defaultValue: 'En attente',
      category: 'payment',
      description: 'Statut paiement en attente'
    },
    'payment.status.rejected': {
      key: 'payment.status.rejected',
      defaultValue: 'Rejeté',
      category: 'payment',
      description: 'Statut paiement rejeté'
    },

    // === PAYMENT METHODS ===
    'payment.method.transfer': {
      key: 'payment.method.transfer',
      defaultValue: 'Virement',
      category: 'payment',
      description: 'Mode de paiement - virement'
    },
    'payment.method.cash': {
      key: 'payment.method.cash',
      defaultValue: 'Espèces',
      category: 'payment',
      description: 'Mode de paiement - espèces'
    },
    'payment.method.card': {
      key: 'payment.method.card',
      defaultValue: 'Carte',
      category: 'payment',
      description: 'Mode de paiement - carte'
    },
    'payment.method.mobile_money': {
      key: 'payment.method.mobile_money',
      defaultValue: 'Mobile Money',
      category: 'payment',
      description: 'Mode de paiement - mobile money'
    },

    // === TABLE HEADERS ===
    'table.date': {
      key: 'table.date',
      defaultValue: 'Date',
      category: 'table',
      description: 'En-tête de colonne - date'
    },
    'table.reference': {
      key: 'table.reference',
      defaultValue: 'Référence',
      category: 'table',
      description: 'En-tête de colonne - référence'
    },
    'table.amount': {
      key: 'table.amount',
      defaultValue: 'Montant',
      category: 'table',
      description: 'En-tête de colonne - montant'
    },
    'table.method': {
      key: 'table.method',
      defaultValue: 'Mode',
      category: 'table',
      description: 'En-tête de colonne - mode de paiement'
    },
    'table.subscription': {
      key: 'table.subscription',
      defaultValue: 'Souscription',
      category: 'table',
      description: 'En-tête de colonne - souscription'
    },
    'table.status': {
      key: 'table.status',
      defaultValue: 'Statut',
      category: 'table',
      description: 'En-tête de colonne - statut'
    },
    'table.actions': {
      key: 'table.actions',
      defaultValue: 'Actions',
      category: 'table',
      description: 'En-tête de colonne - actions'
    },
    'table.project': {
      key: 'table.project',
      defaultValue: 'Projet',
      category: 'table',
      description: 'En-tête de colonne - projet'
    },
    'table.building': {
      key: 'table.building',
      defaultValue: 'Bâtiment',
      category: 'table',
      description: 'En-tête de colonne - bâtiment'
    },
    'table.type': {
      key: 'table.type',
      defaultValue: 'Type',
      category: 'table',
      description: 'En-tête de colonne - type'
    },
    'table.level': {
      key: 'table.level',
      defaultValue: 'Niveau',
      category: 'table',
      description: 'En-tête de colonne - niveau'
    },
    'table.price': {
      key: 'table.price',
      defaultValue: 'Prix convenu',
      category: 'table',
      description: 'En-tête de colonne - prix convenu'
    },
    'table.remaining': {
      key: 'table.remaining',
      defaultValue: 'Restant',
      category: 'table',
      description: 'En-tête de colonne - restant'
    },
    'table.paid': {
      key: 'table.paid',
      defaultValue: 'Payé',
      category: 'table',
      description: 'En-tête de colonne - payé'
    },
    'table.subscription_date': {
      key: 'table.subscription_date',
      defaultValue: 'Date souscription',
      category: 'table',
      description: 'En-tête de colonne - date de souscription'
    },
    'table.delivery_date': {
      key: 'table.delivery_date',
      defaultValue: 'Livraison prévue',
      category: 'table',
      description: 'En-tête de colonne - date de livraison prévue'
    },

    // === SUCCESS MESSAGES ===
    'success.message_sent': {
      key: 'success.message_sent',
      defaultValue: 'Message envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.',
      category: 'success',
      description: 'Message de succès - message envoyé'
    },
    'success.payment_recorded': {
      key: 'success.payment_recorded',
      defaultValue: 'Paiement enregistré avec succès',
      category: 'success',
      description: 'Message de succès - paiement enregistré'
    },
    'success.subscription_created': {
      key: 'success.subscription_created',
      defaultValue: 'Souscription créée avec succès',
      category: 'success',
      description: 'Message de succès - souscription créée'
    },
    'success.profile_updated': {
      key: 'success.profile_updated',
      defaultValue: 'Profil mis à jour avec succès',
      category: 'success',
      description: 'Message de succès - profil mis à jour'
    },

    // === ERROR MESSAGES ===
    'error.loading_data': {
      key: 'error.loading_data',
      defaultValue: 'Erreur lors du chargement des données',
      category: 'error',
      description: 'Message d\'erreur - chargement des données'
    },
    'error.sending_message': {
      key: 'error.sending_message',
      defaultValue: 'Erreur lors de l\'envoi du message. Veuillez réessayer.',
      category: 'error',
      description: 'Message d\'erreur - envoi de message'
    },
    'error.invalid_credentials': {
      key: 'error.invalid_credentials',
      defaultValue: 'Email ou mot de passe incorrect',
      category: 'error',
      description: 'Message d\'erreur - identifiants incorrects'
    },
    'error.network_error': {
      key: 'error.network_error',
      defaultValue: 'Erreur de connexion. Vérifiez votre connexion internet.',
      category: 'error',
      description: 'Message d\'erreur - erreur réseau'
    },
    'error.server_error': {
      key: 'error.server_error',
      defaultValue: 'Erreur du serveur. Veuillez réessayer plus tard.',
      category: 'error',
      description: 'Message d\'erreur - erreur serveur'
    },
    'error.download_invoice': {
      key: 'error.download_invoice',
      defaultValue: 'Erreur lors du téléchargement de la facture',
      category: 'error',
      description: 'Message d\'erreur - téléchargement facture'
    },

    // === BREADCRUMB ===
    'breadcrumb.dashboard': {
      key: 'breadcrumb.dashboard',
      defaultValue: 'Tableau de bord',
      category: 'breadcrumb',
      description: 'Fil d\'Ariane - tableau de bord'
    },
    'breadcrumb.subscriptions': {
      key: 'breadcrumb.subscriptions',
      defaultValue: 'Souscriptions',
      category: 'breadcrumb',
      description: 'Fil d\'Ariane - souscriptions'
    },
    'breadcrumb.payments': {
      key: 'breadcrumb.payments',
      defaultValue: 'Paiements',
      category: 'breadcrumb',
      description: 'Fil d\'Ariane - paiements'
    },
    'breadcrumb.documents': {
      key: 'breadcrumb.documents',
      defaultValue: 'Documents',
      category: 'breadcrumb',
      description: 'Fil d\'Ariane - documents'
    },
    'breadcrumb.profile': {
      key: 'breadcrumb.profile',
      defaultValue: 'Profil',
      category: 'breadcrumb',
      description: 'Fil d\'Ariane - profil'
    },

    // === PLACEHOLDERS ===
    'placeholder.email': {
      key: 'placeholder.email',
      defaultValue: 'votre@email.com',
      category: 'placeholder',
      description: 'Placeholder pour le champ email'
    },
    'placeholder.password': {
      key: 'placeholder.password',
      defaultValue: '••••••••',
      category: 'placeholder',
      description: 'Placeholder pour le champ mot de passe'
    },
    'placeholder.phone': {
      key: 'placeholder.phone',
      defaultValue: '+225 XX XX XX XX XX',
      category: 'placeholder',
      description: 'Placeholder pour le champ téléphone'
    },
    'placeholder.name': {
      key: 'placeholder.name',
      defaultValue: 'Votre nom',
      category: 'placeholder',
      description: 'Placeholder pour le champ nom'
    },
    'placeholder.firstname': {
      key: 'placeholder.firstname',
      defaultValue: 'Vos prénoms',
      category: 'placeholder',
      description: 'Placeholder pour le champ prénoms'
    },
    'placeholder.message': {
      key: 'placeholder.message',
      defaultValue: 'Décrivez votre demande en détail...',
      category: 'placeholder',
      description: 'Placeholder pour le champ message'
    },

    // === TIME FORMATS ===
    'time.today': {
      key: 'time.today',
      defaultValue: 'Aujourd\'hui',
      category: 'time',
      description: 'Format de temps - aujourd\'hui'
    },
    'time.yesterday': {
      key: 'time.yesterday',
      defaultValue: 'Hier',
      category: 'time',
      description: 'Format de temps - hier'
    },
    'time.tomorrow': {
      key: 'time.tomorrow',
      defaultValue: 'Demain',
      category: 'time',
      description: 'Format de temps - demain'
    },
    'time.this_week': {
      key: 'time.this_week',
      defaultValue: 'Cette semaine',
      category: 'time',
      description: 'Format de temps - cette semaine'
    },
    'time.this_month': {
      key: 'time.this_month',
      defaultValue: 'Ce mois',
      category: 'time',
      description: 'Format de temps - ce mois'
    },
    'time.this_year': {
      key: 'time.this_year',
      defaultValue: 'Cette année',
      category: 'time',
      description: 'Format de temps - cette année'
    },

    // === CURRENCY ===
    'currency.fcfa': {
      key: 'currency.fcfa',
      defaultValue: 'FCFA',
      category: 'currency',
      description: 'Devise - Franc CFA'
    },
    'currency.euro': {
      key: 'currency.euro',
      defaultValue: 'EUR',
      category: 'currency',
      description: 'Devise - Euro'
    },
    'currency.dollar': {
      key: 'currency.dollar',
      defaultValue: 'USD',
      category: 'currency',
      description: 'Devise - Dollar américain'
    },
    // Textes pour les demandes de devis
  'devis.title': {
    key: 'devis.title',
    defaultValue: 'Devis',
    category: 'devis',
    description: 'Titre de la page des demandes de devis'
  },
  'devis.description': {
    key: 'devis.description',
    defaultValue: 'Gérez vos demandes de devis pour les projets immobiliers',
    category: 'devis',
    description: 'Description de la page des demandes de devis'
  },
  'devis.new_request': {
    key: 'devis.new_request',
    defaultValue: 'Nouvelle demande de devis',
    category: 'devis',
    description: 'Titre du formulaire de nouvelle demande'
  },
  'devis.select_type': {
    key: 'devis.select_type',
    defaultValue: 'Sélectionnez un type de maison',
    category: 'devis',
    description: 'Placeholder pour la sélection du type de maison'
  },
  'devis.message_optional': {
    key: 'devis.message_optional',
    defaultValue: 'Message (optionnel)',
    category: 'devis',
    description: 'Label pour le message optionnel'
  },
  'devis.send_request': {
    key: 'devis.send_request',
    defaultValue: 'Envoyer la demande',
    category: 'devis',
    description: 'Bouton d\'envoi de demande'
  },
  'devis.my_requests': {
    key: 'devis.my_requests',
    defaultValue: 'Mes demandes de devis',
    category: 'devis',
    description: 'Titre de la section des demandes'
  },
  'devis.no_requests': {
    key: 'devis.no_requests',
    defaultValue: 'Aucune demande de devis pour le moment',
    category: 'devis',
    description: 'Message quand il n\'y a pas de demandes'
  },
  'devis.status.pending': {
    key: 'devis.status.pending',
    defaultValue: 'En attente',
    category: 'devis',
    description: 'Statut en attente'
  },
  'devis.status.accepted': {
    key: 'devis.status.accepted',
    defaultValue: 'Accepté',
    category: 'devis',
    description: 'Statut accepté'
  },
  'devis.status.rejected': {
    key: 'devis.status.rejected',
    defaultValue: 'Refusé',
    category: 'devis',
    description: 'Statut refusé'
  },
  'devis.accept': {
    key: 'devis.accept',
    defaultValue: 'Accepter',
    category: 'devis',
    description: 'Bouton accepter'
  },
  'devis.reject': {
    key: 'devis.reject',
    defaultValue: 'Refuser',
    category: 'devis',
    description: 'Bouton refuser'
  },

  // Textes pour les personnes à contacter
  'contact_persons.title': {
    key: 'contact_persons.title',
    defaultValue: 'Personnes à contacter',
    category: 'contact_persons',
    description: 'Titre de la page des personnes à contacter'
  },
  'contact_persons.description': {
    key: 'contact_persons.description',
    defaultValue: 'Gérez vos personnes à contacter en cas de besoin',
    category: 'contact_persons',
    description: 'Description de la page des personnes à contacter'
  },
  'contact_persons.add': {
    key: 'contact_persons.add',
    defaultValue: 'Ajouter',
    category: 'contact_persons',
    description: 'Bouton d\'ajout'
  },
  'contact_persons.edit': {
    key: 'contact_persons.edit',
    defaultValue: 'Modifier',
    category: 'contact_persons',
    description: 'Bouton de modification'
  },
  'contact_persons.delete': {
    key: 'contact_persons.delete',
    defaultValue: 'Supprimer',
    category: 'contact_persons',
    description: 'Bouton de suppression'
  },
  'contact_persons.no_persons': {
    key: 'contact_persons.no_persons',
    defaultValue: 'Aucune personne à contacter',
    category: 'contact_persons',
    description: 'Message quand il n\'y a pas de personnes'
  },
  'contact_persons.relations': {
    key: 'contact_persons.relations',
    defaultValue: 'Relations',
    category: 'contact_persons',
    description: 'Titre de la section relations'
  },
  'contact_persons.no_relations': {
    key: 'contact_persons.no_relations',
    defaultValue: 'Aucune relation définie',
    category: 'contact_persons',
    description: 'Message quand il n\'y a pas de relations'
  },
  'contact_persons.form.add_person': {
    key: 'contact_persons.form.add_person',
    defaultValue: 'Ajouter une personne à contacter',
    category: 'contact_persons',
    description: 'Titre du formulaire d\'ajout'
  },
  'contact_persons.form.edit_person': {
    key: 'contact_persons.form.edit_person',
    defaultValue: 'Modifier la personne à contacter',
    category: 'contact_persons',
    description: 'Titre du formulaire de modification'
  },
  'contact_persons.form.lastname': {
    key: 'contact_persons.form.lastname',
    defaultValue: 'Nom',
    category: 'contact_persons',
    description: 'Label nom'
  },
  'contact_persons.form.firstname': {
    key: 'contact_persons.form.firstname',
    defaultValue: 'Prénoms',
    category: 'contact_persons',
    description: 'Label prénoms'
  },
  'contact_persons.form.birth_date': {
    key: 'contact_persons.form.birth_date',
    defaultValue: 'Date de naissance',
    category: 'contact_persons',
    description: 'Label date de naissance'
  },
  'contact_persons.form.birth_place': {
    key: 'contact_persons.form.birth_place',
    defaultValue: 'Lieu de naissance',
    category: 'contact_persons',
    description: 'Label lieu de naissance'
  },
  'contact_persons.form.home_phone': {
    key: 'contact_persons.form.home_phone',
    defaultValue: 'Téléphone domicile',
    category: 'contact_persons',
    description: 'Label téléphone domicile'
  },
  'contact_persons.form.work_phone': {
    key: 'contact_persons.form.work_phone',
    defaultValue: 'Téléphone bureau',
    category: 'contact_persons',
    description: 'Label téléphone bureau'
  },
  'contact_persons.form.mobile_phone': {
    key: 'contact_persons.form.mobile_phone',
    defaultValue: 'Téléphone portable',
    category: 'contact_persons',
    description: 'Label téléphone portable'
  },
  'contact_persons.form.profession': {
    key: 'contact_persons.form.profession',
    defaultValue: 'Profession',
    category: 'contact_persons',
    description: 'Label profession'
  },
  'contact_persons.form.city': {
    key: 'contact_persons.form.city',
    defaultValue: 'Ville',
    category: 'contact_persons',
    description: 'Label ville'
  },
  'contact_persons.form.relation_type': {
    key: 'contact_persons.form.relation_type',
    defaultValue: 'Type de relation',
    category: 'contact_persons',
    description: 'Label type de relation'
  },
  'contact_persons.form.is_primary': {
    key: 'contact_persons.form.is_primary',
    defaultValue: 'Personne principale à contacter',
    category: 'contact_persons',
    description: 'Label personne principale'
  },
  'contact_persons.form.cancel': {
    key: 'contact_persons.form.cancel',
    defaultValue: 'Annuler',
    category: 'contact_persons',
    description: 'Bouton annuler'
  },
  'contact_persons.form.save': {
    key: 'contact_persons.form.save',
    defaultValue: 'Sauvegarder',
    category: 'contact_persons',
    description: 'Bouton sauvegarder'
  },
  'contact_persons.form.update': {
    key: 'contact_persons.form.update',
    defaultValue: 'Mettre à jour',
    category: 'contact_persons',
    description: 'Bouton mettre à jour'
  },

  // Textes pour le profil étendu
  'profile.extended.title': {
    key: 'profile.extended.title',
    defaultValue: 'Profil complet',
    category: 'profile',
    description: 'Titre de la page de profil étendu'
  },
  'profile.extended.description': {
    key: 'profile.extended.description',
    defaultValue: 'Gérez toutes vos informations personnelles',
    category: 'profile',
    description: 'Description de la page de profil étendu'
  },
  'profile.sections.basic_info': {
    key: 'profile.sections.basic_info',
    defaultValue: 'Informations de base',
    category: 'profile',
    description: 'Titre section informations de base'
  },
  'profile.sections.personal_info': {
    key: 'profile.sections.personal_info',
    defaultValue: 'Informations personnelles',
    category: 'profile',
    description: 'Titre section informations personnelles'
  },
  'profile.sections.professional_info': {
    key: 'profile.sections.professional_info',
    defaultValue: 'Informations professionnelles',
    category: 'profile',
    description: 'Titre section informations professionnelles'
  },
  'profile.sections.family_info': {
    key: 'profile.sections.family_info',
    defaultValue: 'Situation familiale',
    category: 'profile',
    description: 'Titre section situation familiale'
  },
  'profile.form.birth_date': {
    key: 'profile.form.birth_date',
    defaultValue: 'Date de naissance',
    category: 'profile',
    description: 'Label date de naissance'
  },
  'profile.form.birth_place': {
    key: 'profile.form.birth_place',
    defaultValue: 'Lieu de naissance',
    category: 'profile',
    description: 'Label lieu de naissance'
  },
  'profile.form.nationality': {
    key: 'profile.form.nationality',
    defaultValue: 'Nationalité',
    category: 'profile',
    description: 'Label nationalité'
  },
  'profile.form.id_number': {
    key: 'profile.form.id_number',
    defaultValue: 'N° Pièce d\'identité',
    category: 'profile',
    description: 'Label numéro pièce d\'identité'
  },
  'profile.form.company': {
    key: 'profile.form.company',
    defaultValue: 'Entreprise',
    category: 'profile',
    description: 'Label entreprise'
  },
  'profile.form.profession': {
    key: 'profile.form.profession',
    defaultValue: 'Profession',
    category: 'profile',
    description: 'Label profession'
  },
  'profile.form.monthly_income': {
    key: 'profile.form.monthly_income',
    defaultValue: 'Revenu mensuel (FCFA)',
    category: 'profile',
    description: 'Label revenu mensuel'
  },
  'profile.form.bank_domiciliation': {
    key: 'profile.form.bank_domiciliation',
    defaultValue: 'Domiciliation bancaire',
    category: 'profile',
    description: 'Label domiciliation bancaire'
  },
  'profile.form.marital_status': {
    key: 'profile.form.marital_status',
    defaultValue: 'Statut marital',
    category: 'profile',
    description: 'Label statut marital'
  },
  'profile.form.marital_regime': {
    key: 'profile.form.marital_regime',
    defaultValue: 'Régime matrimonial',
    category: 'profile',
    description: 'Label régime matrimonial'
  },
  'profile.form.children_count': {
    key: 'profile.form.children_count',
    defaultValue: 'Nombre d\'enfants',
    category: 'profile',
    description: 'Label nombre d\'enfants'
  },
  'profile.form.select_status': {
    key: 'profile.form.select_status',
    defaultValue: 'Sélectionnez un statut',
    category: 'profile',
    description: 'Placeholder sélection statut'
  },
  'profile.form.select_regime': {
    key: 'profile.form.select_regime',
    defaultValue: 'Sélectionnez un régime',
    category: 'profile',
    description: 'Placeholder sélection régime'
  }
  };

  // Fonction utilitaire pour récupérer un texte par sa clé
  export const getText = (key: string, texts?: Record<string, string>): string => {
    if (texts && texts[key]) {
      return texts[key];
    }
    return TEXT_KEYS[key]?.defaultValue || key;
  };

  // Fonction pour obtenir toutes les clés d'une catégorie
  export const getTextsByCategory = (category: string): Record<string, TextKey> => {
    return Object.fromEntries(
      Object.entries(TEXT_KEYS).filter(([_, textKey]) => textKey.category === category)
    );
  };

  // Fonction pour obtenir toutes les catégories
  export const getCategories = (): string[] => {
    return [...new Set(Object.values(TEXT_KEYS).map(textKey => textKey.category))];
  };

  